var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewRoomsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4567_16471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2942V3.70626C0 3.48559 0.136896 3.28806 0.343504 3.21057L8.81387 0.0341796C8.94584 -0.0153192 9.08119 -0.0087088 9.19816 0.0388916L17.656 3.21057C17.8626 3.28806 17.9995 3.48559 17.9995 3.70626V14.2942C17.9995 14.5339 17.8443 14.7257 17.6409 14.7956L9.18564 17.9663C9.06579 18.0113 8.93372 18.0113 8.81387 17.9663L0.35862 14.7956C0.155176 14.7257 0 14.5339 0 14.2942ZM14.8232 12.7362L16.9407 13.5303V6.72013L9.52914 3.94078V10.751L11.1173 11.3465V6.55177C11.1173 6.18215 11.4865 5.92629 11.8326 6.05608L14.4796 7.04869C14.6862 7.12618 14.8231 7.32371 14.8231 7.54438V12.7362H14.8232ZM12.1762 7.3157V11.7436L13.7643 12.3392V7.91127L12.1762 7.3157ZM2.03711 14.2942L8.99977 16.9052L15.9624 14.2942L8.99977 11.6833L2.03711 14.2942ZM8.47037 3.94078L1.05877 6.72013V13.5303L8.47037 10.751V3.94078ZM9.52918 2.81001L16.9408 5.58936V4.07314L9.52918 1.2938V2.81001ZM1.05877 5.58936L8.47037 2.81001V1.2938L1.05877 4.07314V5.58936ZM2.11758 10.8531V8.20615C2.11758 7.98548 2.25448 7.78794 2.46109 7.71046L6.69629 6.12228C7.04239 5.99249 7.41156 6.24835 7.41156 6.61797V9.26496C7.41156 9.48563 7.27466 9.68316 7.06806 9.76065L2.83285 11.3488C2.48679 11.4786 2.11758 11.2228 2.11758 10.8531ZM6.35279 8.89808V7.38186L3.17639 8.57299V10.0892L6.35279 8.89808Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4567_16471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRoomsIcon);
export default __webpack_public_path__ + "static/media/ViewRoomsIcon.1ac6488fd28a94778f2a96cb462a67c6.svg";
export { ForwardRef as ReactComponent };